module.exports = __webpack_public_path__ + "static/media/crowdedness.9a501014.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/canteen/crowdedness.jpg
// module id = 674
// module chunks = 0